import { Box, Typography } from '@mui/material';

declare const __APP_VERSION__: string;

const isDev = import.meta.env.VITE_ENVIRONMENT === 'development';

export function DevBanner() {
  if (!isDev) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.tooltip + 1,
        bgcolor: '#f59e0b',
        py: 0.4,
        textAlign: 'center',
        pointerEvents: 'none',
      }}
    >
      <Typography variant="caption" sx={{ color: '#1c1917', fontWeight: 700, letterSpacing: 0.3 }}>
        ⚠ AMBIENTE DE DESENVOLVIMENTO — dev-api.dominoris.com.br · v{__APP_VERSION__}
      </Typography>
    </Box>
  );
}
